angular.module("files_types_whitelist")

    .controller("FilesTypesWhitelistEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {
        
            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_TYPES_WRITE");
            $rootScope.title = $filter('translate')('files_types_whitelist.title');

            $scope.type_whitelist = {};

            $scope.selectEntities = [{ id: 'events', name: $filter('translate')('files_types_whitelist.events_files')},
                { id: 'programs', name: $filter('translate')('files_types_whitelist.events_programs')},
                { id: 'events_programs_annexes', name: $filter('translate')('files_types_whitelist.events_annexes')},
                { id: 'general', name: $filter('translate')('files_types_whitelist.general') },
                { id: 'mailings', name: $filter('translate')('files_types_whitelist.mailings') },
                { id: 'correspondence', name: $filter('translate')('files_types_whitelist.correspondence') },
                { id: 'restaurants', name: $filter('translate')('files_types_whitelist.restaurants') },
                { id: 'staff', name: $filter('translate')('files_types_whitelist.staff') },
                { id: 'documents_config', name: $filter('translate')('files_types_whitelist.documents_config') },
                { id: 'persons', name: $filter('translate')('files_types_whitelist.persons') }
            ];

            Restangular.all('FilesTypes').getList().then(function (result) {
                $scope.selectFilesTypes = result;
            });

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('files_types_whitelist.title'), url: "files_types_whitelist.list" },
                    { title: $filter('translate')('files_types.title_add') },
                ];
             
            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('files_types_whitelist.title'), url: "files_types_whitelist.list" },
                    { title: $filter('translate')('files_types.title_edit') },
                ];

                Restangular.one('FilesTypesWhitelist', $stateParams.id).get().then(function (result) {
                    $scope.type_whitelist = result;
                });
            }               
                                       
            $scope.save = function () {            
                if (angular.isDefined($scope.type_whitelist.id)) {
                    $scope.type_whitelist.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('general.edit_success'));                        
                            $state.go("files_types_whitelist.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('FilesTypesWhitelist').post($scope.type_whitelist).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('general.save_success'));
                            $state.go("files_types_whitelist.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('general.button_delete'),
                    message: $filter('translate')('general.delete_message') + " " + $scope.event_type.name + "?",
                    onAccept: function () {
                        $scope.type_whitelist.remove().then(function () {
                            toastr.success($filter('translate')('general.deleted_success'));
                            $state.go("files_types_whitelist.list");
                        });
                    }
                });
            };        

        }])

;

